import ArrowClockwiseBold from './ArrowClockwiseBold';

export default ArrowClockwiseBold;
